exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".row-flex-align-bottom[data-v-2bd05245]{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.row-flex-align-bottom>div a[data-v-2bd05245]{cursor:pointer;display:block;margin-bottom:15px}.row-flex-align-bottom>div[data-v-2bd05245]{-ms-flex-item-align:end;align-self:flex-end}label[data-v-2bd05245]{font-size:16px;font-weight:400}.data-details[data-v-2bd05245]{margin-bottom:100px}.arrow-img[data-v-2bd05245]{height:7px;margin-bottom:4px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2bd05245","scoped":true,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dashboard/my-data/medical-data.vue
// module id = 877
// module chunks = 0